// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.manufacture-table-container {
  position: relative;
  margin-top: 20px;
  overflow: hidden;
  height: calc(100vh - var(--header-height, 100px));
}
@media (max-width: 768px) {
  .manufacture-table-container {
    height: calc(100vh - var(--header-height, 250px));
  }
}

.manufacture-table-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.manufacture_column {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 4;
  background-color: white !important;
}

.manufacture_column::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #dee2e6;
}

.manufacture_td {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: white !important;
  border: 2px solid #ada5a5 !important;
}

.manufacture_thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: white !important;
}

.highlighted-row {
  background-color: #565656 !important; /* Цвет фона для выделенной строки */
  font-weight: bold; /* Жирный шрифт для текста в выделенной строке */
  /* Другие стили, если необходимо */
  color: white !important;
}

.manufacture_column.highlighted-row {
  background-color: #565656 !important;
  font-weight: bold !important;
  color: white;
}

.manufacture-top__thead, .manufacture-top__tbody {
  border-color: transparent;
}
.manufacture-top__td {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: white !important;
  font-size: 18px;
  color: #000000;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0px !important;
}
@media (max-width: 490px) {
  .manufacture-top__td {
    font-size: 12px;
  }
}
.manufacture-top__quantity {
  font-size: 16px;
  text-align: center;
  padding: 0px !important;
  color: #000000;
  font-weight: 700;
}
@media (max-width: 490px) {
  .manufacture-top__quantity {
    font-size: 13px;
  }
}

.manufacture-table__thead {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 5;
  color: #000000;
  background-color: #ada5a5 !important;
  padding: 0px !important;
  text-align: center;
}
@media (max-width: 490px) {
  .manufacture-table__thead {
    font-size: 12px;
  }
}
.manufacture-table__thead-detail {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  color: #000000;
  background-color: #ada5a5 !important;
}
@media (max-width: 490px) {
  .manufacture-table__thead-detail {
    font-size: 12px;
  }
}

.manufacture-fulltable__thead {
  text-align: center;
  background-color: #ffffff !important;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
}
.manufacture-fulltable__thead.detail {
  width: 70px;
  z-index: 5;
}
.manufacture-fulltable__thead.detail::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
}
.manufacture-fulltable__td {
  text-align: center;
}
.manufacture-fulltable__td.detail {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: white !important;
}
.manufacture-fulltable__td.detail::after {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  width: 1px;
  height: 100%;
}

.button-manufacture__fulltable {
  width: 80px;
  height: 30px;
  border: 2px solid #212529;
  background-color: #212529;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
}
.button-manufacture__fulltable.active {
  background-color: #212529; /* Черный фон для активной кнопки */
  color: #ffffff; /* Белый текст для активной кнопки */
}
@media (max-width: 460px) {
  .button-manufacture__fulltable {
    width: 50px;
    height: 20px;
    font-size: 10px;
  }
}

.inactive {
  background-color: #ffffff; /* Белый фон для неактивной кнопки */
  color: #212529; /* Черный текст для неактивной кнопки */
}`, "",{"version":3,"sources":["webpack://./src/components/ManufactureList/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iDAAA;AAEJ;AADI;EALJ;IAMQ,iDAAA;EAIN;AACF;;AADA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,iCAAA;EACA,4BAAA;AAIJ;;AAEA;EACE,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;AACF;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AACJ;;AAEE;EACE,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;EACA,oCAAA;AACJ;;AAEM;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;AACR;;AAKE;EACE,oCAAA,EAAA,oCAAA;EACA,iBAAA,EAAA,gDAAA;EACA,kCAAA;EACA,uBAAA;AAFJ;;AAKE;EACE,oCAAA;EACA,4BAAA;EACA,YAAA;AAFJ;;AAMI;EACI,yBAAA;AAHR;AAMI;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;AAJR;AAKQ;EAXJ;IAYQ,eAAA;EAFV;AACF;AAKI;EACI,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;AAHR;AAIQ;EANJ;IAOQ,eAAA;EADV;AACF;;AAOI;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,oCAAA;EACA,uBAAA;EACA,kBAAA;AAJR;AAKQ;EATJ;IAUQ,eAAA;EAFV;AACF;AAKI;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,oCAAA;AAHR;AAKQ;EARJ;IASQ,eAAA;EAFV;AACF;;AAQI;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;AALR;AAQI;EACI,WAAA;EACA,UAAA;AANR;AASI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;AAPR;AAUI;EACI,kBAAA;AARR;AAWI;EACI,gBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,kCAAA;AATR;AAaI;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;AAXR;;AAmBI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAhBR;AAiBQ;EACI,yBAAA,EAAA,mCAAA;EACA,cAAA,EAAA,oCAAA;AAfZ;AAiBQ;EAfJ;IAgBQ,WAAA;IACA,YAAA;IACA,eAAA;EAdV;AACF;;AAmBA;EACI,yBAAA,EAAA,oCAAA;EACA,cAAA,EAAA,uCAAA;AAhBJ","sourcesContent":[".manufacture-table-container {\n    position: relative;\n    margin-top: 20px; \n    overflow: hidden;\n    height: calc(100vh - var(--header-height, 100px));\n    @media(max-width: 768px) {\n        height: calc(100vh - var(--header-height, 250px));\n    }\n}\n  \n.manufacture-table-wrapper {\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n  \n   \n  \n}\n  \n.manufacture_column {\n  position: sticky;\n  left: 0;\n  top: 0;\n  z-index: 4;\n  background-color: white !important;\n}\n\n.manufacture_column::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 1px;\n    height: 100%;\n    background-color: #dee2e6; \n  }\n\n  .manufacture_td {\n    position: sticky;\n    left: 0;\n    top: 0;\n    z-index: 3;\n    background-color: white !important; \n    border: 2px solid #ada5a5 !important;\n      }\n\n      .manufacture_thead {\n        position: sticky;\n        top: 0;\n        z-index: 1;\n        background-color: white !important; \n    }\n    \n    \n  \n\n  .highlighted-row {\n    background-color: #565656 !important; /* Цвет фона для выделенной строки */\n    font-weight: bold; /* Жирный шрифт для текста в выделенной строке */\n    /* Другие стили, если необходимо */\n    color: #ffff !important;\n  }\n\n  .manufacture_column.highlighted-row {\n    background-color: #565656 !important;\n    font-weight: bold !important;\n    color: #ffff;\n  }\n\n.manufacture-top {\n    &__thead, &__tbody {\n        border-color: transparent;\n    }\n\n    &__td {\n        position: sticky;\n        left: 0;\n        top: 0;\n        z-index: 3;\n        background-color: white !important; \n        font-size: 18px;\n        color: #000000;\n        font-weight: 700;\n        text-transform: uppercase;\n        padding: 0px !important;\n        @media(max-width: 490px) {\n            font-size: 12px;\n        }\n    }\n\n    &__quantity {\n        font-size: 16px;\n        text-align: center;\n        padding: 0px !important;\n        color: #000000;\n        font-weight: 700;\n        @media(max-width: 490px) {\n            font-size: 13px;\n        }\n       \n    }\n}\n\n.manufacture-table {\n    &__thead {\n        position: sticky;\n        left: 0;\n        top: 0;\n        z-index: 5;\n        color: #000000;\n        background-color: #ada5a5 !important;\n        padding: 0px !important;\n        text-align: center;\n        @media(max-width: 490px) {\n            font-size: 12px;\n        }  \n    }\n\n    &__thead-detail {\n        position: sticky;\n        left: 0;\n        top: 0;\n        z-index: 3;\n        color: #000000;\n        background-color: #ada5a5 !important;\n      \n        @media(max-width: 490px) {\n            font-size: 12px;\n        }\n    }\n\n}\n\n.manufacture-fulltable {\n    &__thead {\n        text-align: center;\n        background-color: #ffffff !important;\n        position: sticky;\n        left: 0;\n        top: 0;\n        z-index: 3;\n    }\n\n    &__thead.detail {\n        width: 70px;\n        z-index: 5;\n    }\n\n    &__thead.detail::after {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        right: 0;\n        height: 100%;\n        width: 100%;\n    }\n\n    &__td {\n        text-align: center;\n    }\n\n    &__td.detail{\n        position: sticky;\n        left: 0;\n        top: 0;\n        z-index: 3;\n        background-color: white !important; \n        \n    }\n    \n    &__td.detail::after {\n        content: '';\n        position: absolute;\n        top: 0px;\n        right: 0px;\n        width: 1px;\n        height: 100%;\n        \n     \n            \n    }\n}\n\n.button-manufacture {\n    &__fulltable {\n        width: 80px;\n        height: 30px;\n        border: 2px solid #212529;\n        background-color: #212529;\n        color: #ffffff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 14px;\n        font-weight: 500;\n        &.active {\n            background-color: #212529; /* Черный фон для активной кнопки */\n            color: #ffffff; /* Белый текст для активной кнопки */\n        }\n        @media(max-width: 460px) {\n            width: 50px;\n            height: 20px;\n            font-size: 10px;\n            \n        }\n    }\n}\n\n.inactive {\n    background-color: #ffffff; /* Белый фон для неактивной кнопки */\n    color: #212529; /* Черный текст для неактивной кнопки */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
